/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {
      
    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeIds   : google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#bbb8b8"}]},{"featureType":"administrative.province","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#8c8c8c"}]},{"featureType":"administrative.province","elementType":"geometry.fill","stylers":[{"visibility":"off"},{"color":"#6d6d6d"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#a8a8a8"},{"weight":"1"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"lightness":17},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]}]
        /*styles: [ 
            { 
                "featureType": "poi", 
                "stylers": [ 
                    { "visibility": "off" } 
                ] 
            } 
        ]*/
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Marker icons
    console.log('marker count: ' + $markers.size())
    var image = {
        url: '',
        scaledSize: new google.maps.Size(30, 30)
    }

    if ($el.hasClass('alt')) {
      image.url = '//selectsurfaces.com/cdn/shop/t/7/assets/map-pin-alt.svg?v=83964877080040913151746219350'
    } else {
      image.url = '//selectsurfaces.com/cdn/shop/t/7/assets/map-pin.svg?v=183881499014171110371746219350'
    }
    
    // Add markers
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), image, map );
    });

    // Center map based on markers
    centerMap( map );

    // Map nav
    $('.map-nav .location:not(.active)').on('click', function($el) {

      // reset
      map.markers.forEach(function( marker ){
          marker.setIcon(image)
      });
      $('.map-nav .location').removeClass('active');
      // activate
      var id = $(this).data('id');
      var lat = $('.map-nav .location[data-id="' + id + '"]').data('lat');
      var lng = $('.map-nav .location[data-id="' + id + '"]').data('lng');
      console.log('marker id: ' + id)
      
      map.markers[id].setIcon({url: '//selectsurfaces.com/cdn/shop/t/7/assets/map-pin.svg?v=183881499014171110371746219350',scaledSize: new google.maps.Size(40, 40)});
      var center = new google.maps.LatLng(lat, lng);
      map.panTo(center);
      // panel
      $(this).addClass('active');    

    })
  
    // Map closest
    $('#find-closest').click(function() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                var userLocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                var nearestLocation = findNearestLocation(userLocation); 
                $('.map-nav .location[data-id="' + nearestLocation.metadata.id + '"] .expand-btn').trigger('click');
                var loc = $('.map-nav .location[data-id="' + nearestLocation.metadata.id + '"] .button').data('location');
                $('#find-closest-info strong').text('Nearest Location: ' + loc);
            }, function() {
                console.log('Error: The Geolocation service failed.'); 
            });
        } else {
            console.log('Error: Your browser doesn\'t support geolocation.'); 
        }
    });
    function findNearestLocation(userLocation) {
        var nearestLocation;
        var nearestDistance = Number.MAX_VALUE;
        for (var i = 0; i < map.markers.length; i++) {
            var marker = map.markers[i];
            var distance = google.maps.geometry.spherical.computeDistanceBetween(
                new google.maps.LatLng(userLocation.lat, userLocation.lng),
                marker.getPosition()
            );   
            if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestLocation = marker;
            }
        }
        return nearestLocation;
    }

    // Return map instance
    return map;

}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, image, map) {

    // Get position from marker.
    var id = $marker.data('id');
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };
    var link = $marker.data('link');
    var title = $marker.data('title');

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        icon: image,
        map: map,
    });
    marker.metadata = {type: "point", id: id - 1, link: link, title};

    // Append to reference for later use.
    map.markers.push( marker );

    function activateMarker(id) {
      var lat = $('.map-nav .location[data-id="' + id + '"]').data('lat');
      var lng = $('.map-nav .location[data-id="' + id + '"]').data('lng');
      console.log('marker id: ' + id)
      map.markers[id].setIcon({url: '//selectsurfaces.com/cdn/shop/t/7/assets/map-pin.svg?v=183881499014171110371746219350',scaledSize: new google.maps.Size(40, 40)});
      var center = new google.maps.LatLng(lat, lng);
      map.panTo(center);
    }
  
    // Marker Click
    google.maps.event.addListener(marker, 'click', function() {
        // reset
        map.markers.forEach(function( marker ){
            marker.setIcon(image)
        });
        $('.map-nav .location').removeClass('active');

        if (link) {
          // no nav
          window.open(link,'_blank');
        } else {
          // contact lightbox
          if ($('.map').parent().parent().hasClass('lightbox')) {
            var title = marker.metadata.title;
            console.log(title);
            $('.map').parent().find('select').val(title);
            $('.map').parent().find('select').change();
            $('.map').parent().find('select')[0].dispatchEvent(new CustomEvent('change'));
          }
          // activate
          var id = marker.metadata.id;
          activateMarker(id);
          // panel
          if ($('.map-nav').hasClass('w-expands')) {
            $('.map-nav .expand-btn').removeClass('expanded');
            $('.map-nav .location[data-id="' + id + '"] .expand-btn').addClass('expanded');
          } else {
            $('.map-nav .location[data-id="' + id + '"]').addClass('active');
          }
        }

    });

    // Select change
    function findMarkerByTitle(title) {
      for (var i = 0; i < map.markers.length; i++) {
        if (map.markers[i].metadata.title === title) {
          return map.markers[i];
        }
      }
      return null;
    }
    $(document).on('change', '.lightbox.w-map select', function() {
      var selectedTitle = $(this).val();
      console.log(selectedTitle);
      var marker = findMarkerByTitle(selectedTitle);
      if (marker) {
        var id = marker.metadata.id;
        activateMarker(id);
      }
    });
    
    // If marker contains HTML, add it to an infoWindow.
    /*if( $marker.html() ){
        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });
        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }*/
}


/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}






// Render maps on page load.
$(document).ready(function(){
    $('.map').each(function(){
        var map = initMap( $(this) );
    });
});



